export class Conditions {
  CURRENT_DATA = {};
  DATA_FROM_TABLE = {};

  constructor(CURRENT_DATA = {}, DATA_FROM_TABLE) {
    this.CURRENT_DATA = CURRENT_DATA;
    this.DATA_FROM_TABLE = DATA_FROM_TABLE;
  }

  SplitExpressionOperators(expression) {
    const regex = /^(\$\w+)\((.+)\)$/;
    const match = expression.match(regex);

    if (!match) return [undefined, undefined];

    let [_, operator, content] = match;
    let openParens = 0;
    let splitIndex = -1;

    for (let i = 0; i < content.length; i++) {
      if (content[i] === "(") openParens++;
      else if (content[i] === ")") openParens--;

      if (openParens === 0) {
        splitIndex = i + 1;
        break;
      }
    }

    if (splitIndex === content.length) {
      return [operator, content.slice(0, splitIndex)];
    } else {
      return [operator, content];
    }
  }

  convertConstant(condition) {
    switch (condition) {
      case "#NULL":
        return null;

      default:
        return condition;
    }
  }

  convertBuiltInFunc(condition) {
    const [type, result] = this.SplitExpressionOperators(condition);

    switch (type) {
      case "$toNumber":
        return Number(this.convert(result));
      case "$current":
        return this.CURRENT_DATA[result];
      case "$from":
        const [table, field] = result.split(".");
        return this.DATA_FROM_TABLE?.[table]?.map((item) => item?.[field]);
      case "$variable":
        return this.CURRENT_DATA[result];
      case "$sum":
        const regex = /^\$sum\((.*)\)$/;
        const match = condition.match(regex);
        const items = match?.[1]?.split(",");
        let total = 0;
        for (const item of items) {
          total += Number(this.convert(item) || 0);
        }
        return total;
      default:
        return condition;
    }
  }

  convert(condition) {
    switch (condition[0]) {
      case "$":
        return this.convertBuiltInFunc(condition);
      case "#":
        return this.convertConstant(condition);
      default:
        return condition;
    }
  }

  convertToArray(value) {
    return Array.isArray(value) ? value : [value];
  }

  isArray(value, position = 0) {
    if (Array.isArray(value)) {
      return value?.[position] || null;
    }
    return value;
  }

  compare(first_value, second_value, type) {
    switch (type) {
      case "=":
        return (
          this.isArray(first_value?.value, first_value?.position) ===
          this.isArray(second_value?.value, second_value?.position)
        );
      case ">":
        return (
          this.isArray(first_value?.value, first_value?.position) >
          this.isArray(second_value?.value, second_value?.position)
        );
      case "<=":
        return (
          this.isArray(first_value?.value, first_value?.position) <=
          this.isArray(second_value?.value, second_value?.position)
        );
      case "!=":
        return (
          this.isArray(first_value.value, first_value.position) !==
          this.isArray(second_value.value, second_value.position)
        );
      case "some":
        first_value = this.convertToArray(first_value);
        second_value = new Set(this.convertToArray(second_value));

        for (const index in first_value) {
          const item = first_value[index];
          if (second_value.has(item) === true) {
            return true;
          }
        }

        return false;

      default:
        return false;
    }
  }
}
